<template>
  <table
    :class="$style.table"
    v-bind="$attrs"
  >
    <slot />
  </table>
</template>

<style module lang="scss">
.table {
  position: relative;
}
</style>
